import React from 'react';
import DocsViewer from '../components/DocsViewer';

const ApiDocs = () => {
  return (
    <DocsViewer
      docsType="api"
      title="Promang API Documentation"
    />
  );
};

export default ApiDocs;

